import { AxiosResponse } from "axios";
import { CacheAxiosResponse } from "axios-cache-interceptor";

import { axios } from "../api";

import type {
  AeronetV6Response,
  Currency,
  CurrencyCreate,
  CurrencyUpdate,
} from "../types";

/** Returns the currencies */
export function getCurrencies(): Promise<
  CacheAxiosResponse<AeronetV6Response<Currency>>
> {
  return axios.get<AeronetV6Response<Currency>>("/v6/currency", {
    cache: false,
  });
}

/** Returns a single currency by id */
export function getCurrency(
  id: number
): Promise<CacheAxiosResponse<Currency>> {
  return axios.get<Currency>(`/v6/currency/${id}`, { cache: false });
}

/** Creates a new currency */
export function createCurrency(
  body: CurrencyCreate
): Promise<AxiosResponse<Currency>> {
  return axios.post<Currency>("/v6/currency", body, { cache: false });
}

/** Updates an existing currency (partial) */
export function updateCurrency(
  id: number,
  body: CurrencyUpdate
): Promise<AxiosResponse<Currency>> {
  return axios.put<Currency>(`/v6/currency/${id}`, body, { cache: false });
}

/** Deletes a currency */
export function deleteCurrency(id: number): Promise<AxiosResponse<void>> {
  return axios.delete<void>(`/v6/currency/${id}`, { cache: false });
}

export interface CurrencyRefreshResponse {
  updated: number;
  skipped: string[];
  base: string;
}

/** Refreshes `exchange` for the given currency ids from a public FX API */
export function refreshCurrencyRates(
  ids: number[]
): Promise<AxiosResponse<CurrencyRefreshResponse>> {
  return axios.post<CurrencyRefreshResponse>(
    "/v6/currency/refresh-rates",
    { ids },
    { cache: false }
  );
}
